<script>
import FeaturePlaceholder from './FeaturePlaceholder.vue';
import Logo from 'next/icon/Logo.vue';
export default {
  components: { FeaturePlaceholder, Logo },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <div class="flex flex-col items-center justify-center h-full">
    <Logo class="m-4 size-16" />
    <span class="text-sm text-n-slate-12 font-medium text-center">
      {{ message }}
      <br />
    </span>
    <!-- Cmd bar, keyboard shortcuts placeholder -->
    <FeaturePlaceholder />
  </div>
</template>
